import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeDialog, expandTile } from "../../../store/actions";

interface IProps {
  tileId: number;
  tileTypeName: string;
  price: number;
}

const mapStateToProps = (state: any) => ({
  gold: state.governorate.resources.gold
});

const mapDispatchToProps = (dispatch: any) => ({
  expandTile: (tileId: number) => dispatch(expandTile(tileId)),
  closedDialog: () => dispatch(closeDialog())
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const ExpandTile = (props: IProps & ConnectedProps<typeof connector>) => (
  <>
    <div className="dialog-content">
      <table className="table">
          <tr>
            <td>
              <strong>Expand {props.tileTypeName}?</strong>
            </td>
          </tr>
      </table>
    </div>
    <footer className="dialog-footer">
      <a href="#" onClick={props.closedDialog} className="btn btn-blank btn-no-width">CANCEL</a>
      <a href="#"
         className={`btn btn-blank btn-no-width ${props.gold < props.price ? "disabled" : ""}`}
         onClick={() => props.expandTile(props.tileId)}
      >
          {props.price}
          <i className="icon icon-standalone icon-zlato gold"/>
      </a>
    </footer>
  </>
)

export default connector(ExpandTile);
